// create audience api
import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getReportParticipantInfo: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/{participantId}/audience-info`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getReportParticipantInfo = async (presentationId, participantId) => {
  const res = await resource.getReportParticipantInfo({ participantId, presentationId })
  return res.body
}

export default {
  initResource,
  getReportParticipantInfo,
}
